
import React from 'react'
import { useEffect ,useState} from 'react';
import axios from 'axios';
import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import BlogBanner from "../../../images/background/homeBanner.jpg"

function Blog() {

    const [blogs, setBlogs] = useState(null);
  const [showAddBlog, setShowAddBlog] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getAllBlogs();
  }, []);

  const getAllBlogs = () => {
    // const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`http://localhost:52712/api/Admin/GETBlogs?id=0`, {
        headers: {
        //   Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {

        console.log(response.data.data)
        setBlogs(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  };

  const getCurrentBlogImage = (image) => {
    const baseImageURL = "http://localhost:52712/"; 
return `${baseImageURL}Images/Blogs/${image}`;
  };
  

  return (
    <section>
 <div class="page-wrapper">
    <Header/>
        <section class="page-title sp-six"  style={{ backgroundImage: `url(${BlogBanner})` }}>
            <div class="container">
                <div class="page-title-area text-center">
                    <div class="title-text">
                        <h1>Our Articles</h1>
                    </div>
                    <ul class="page-list">
                        <li><a href="index.html">home</a></li>
                        <li>-</li>
                        <li>Our Articles</li>
                    </ul>
                </div>                
            </div>
        </section>
        <section class="blog-section sp-seven">
            <div class="container">
                <div class="row">
                    {blogs && blogs.length>0?
blogs.map((blog,idx)=>{
    return <div  key={idx} class="news-block-one col-xl-4 col-lg-6 col-sm-12">
    <div class="inner-box">
        <div class="image">
            <img src={getCurrentBlogImage(blog.ImagePath)} alt={blog.ImagePath} />
            <a  href={`http://localhost:52712/Images/Blogs/${blog.ImagePath}`}> </a>
            <div class="overlay-link">
                <div class="icon-box">
                    <a href={`/blog/${blog.URL}`}><i class="flaticon-expand-screen"></i></a>
                </div>                                
            </div>
        </div>
        <div class="lower-content">
            <h5><a href={`/blog/${blog.URL}`}>{blog.MetaTitle}</a></h5>
            <ul class="blog-info mt-15 mb-15">
                <li><i class="fa fa-user"></i><a href="#">admin</a></li>
                <li><i class="fa fa-calendar"></i>350</li>
                <li><i class="fa fa-commenting-o"></i>30</li>
            </ul>
            <p>
                {blog.MetaDescription}
                </p>
            <div class="link-btn">
                <a href={`/blog/${blog.URL}`} class="theme-btn btn-style-five">Read More</a>
            </div>
        </div>
    </div>
</div>
})
                :
                null    
                }
    
                </div>
            </div>
        </section>
    </div>
   
    <button class="scroll-top scroll-to-target" data-target="html">
        <span class="fa fa-arrow-up"></span>
    </button>
<Footer/>
    
    </section>
  )
}

export default Blog
